export default __webpack_public_path__ + "static/media/innocentnew.60615ef7.jpeg";